import { render } from "./HeroContainer.vue?vue&type=template&id=88aa8b74"
import script from "./HeroContainer.vue?vue&type=script&lang=js"
export * from "./HeroContainer.vue?vue&type=script&lang=js"

import "./HeroContainer.vue?vue&type=style&index=0&id=88aa8b74&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__